import type { InterventionGroupTemplateResponse } from '../../api/generated';

// Total number of interventions across the given template groups.
export const countInterventions = (groups: InterventionGroupTemplateResponse[]): number =>
  groups.reduce((sum, group) => sum + group.interventions.length, 0);

// Sum of the reimbursement amounts across the given template groups.
export const sumReimbursement = (groups: InterventionGroupTemplateResponse[]): number =>
  groups.reduce((sum, group) => sum + (group.reimbursementAmount ?? 0), 0);
